import { useLocation } from 'react-router-dom';

import { WizardResultRouterState } from '../types';

export const useWizardResultRouterState = () => useLocation<WizardResultRouterState>().state;
